import React, { useContext, useEffect, useState } from "react";
import "./products-content.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@material-ui/core";
import { DataTableComponent } from "../../../../components/table/data-table/data-table.component";
import { MapperService } from "../../../../services/mapper/mapper.service";
import { ProductsContext } from "../../../../store";
import { defaultItems } from "../../../../statics/pagination";
import { ProductsService } from "../../../../services/products.services";
import AddProductModal from "../../modals/add-product/add-product.modal";
import { icons } from "../../../../statics/icons";

const ProductsContent = () => {
  const { t } = useTranslation();
  const productsService = new ProductsService();
  const mapperService = new MapperService();
  const emptyArr: any = [];
  const {
    products,
    columns,
    setProducts,
    setPagination,
    options,
    pagination,
    sort,
    setFilter,
    filter,
  } = useContext(ProductsContext);

  const [showAddProductModal, setShowAddProductModal] = useState(false);

  const [loading, setLoading] = useState(true);
  const [reset, setReset] = useState(false);
  const [counts, setCounts] = useState({
    approved: 0,
    inprogress: 0,
    untrusted: 0,
    notSelected: 0,
    total: 0,
  });

  const refresh = (action: string) => {
    let page = pagination.currentPage;
    if (products.length === 1 && action === "delete") {
      page = pagination.currentPage === 1 ? 1 : pagination.currentPage - 1;
    }
    const filterObj = {
      ...filter,
      page,
      items: pagination.items,
      sort: options.sortColumn,
      order: options.sortDirection,
    };
    fetchData(filterObj);
  };

  const fetchData = async (filter?: any) => {
    setProducts(emptyArr);
    setLoading(true);
    const productsList = await productsService.pagination(filter);
    if (!productsList) {
      return;
    }
    const { counts, products, paginationObj } = mapperService.mapProducts(
      productsList,
    );
    setProducts(products);
    setPagination(paginationObj);
    setCounts(counts);
    setLoading(false);
    setReset(false);
  };

  const refreshData = () => {
    setFilter({ role: "", searchText: "", status: null });
    setReset(true);
    const paginationParams = { items: defaultItems, page: 1 };
    fetchData(paginationParams);
  };

  const sortTable = (fieldName: string, sortDirection: string) => {
    const params = { fieldName, sortDirection };
    const filterObj = {
      ...filter,
      page: 1,
      items: pagination.items,
      sort: fieldName,
      order: sortDirection,
    };
    fetchData(filterObj);
    return sort(params);
  };

  const paginateTable = (pagination: any) => {
    const { items, currentPage } = pagination;
    const params = {
      ...filter,
      items,
      page: currentPage,
      order: options.sortDirection,
      sort: options.sortColumn,
    };
    fetchData(params);
  };

  const filterChange = (params: any) => {
    const filterObj: any = {
      items: pagination.items,
      page: 1,
      ...params,
    };
    setFilter(params);
    fetchData(filterObj);

    sort({
      fieldName: "",
      sortDirection: "",
    });
  };

  const handleModalClose = (value: any) => {
    setTimeout(() => {
      setShowAddProductModal(false);
    }, 0);
    if (value) {
      refreshData();
    }
  };

  useEffect(() => {
    refreshData();
    // eslint-disable-next-line
  }, []);

  return (
    <Box className="products__content">
      <Box className="d-flex align-items-center justify-content-between mb-4">
        <Box className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
          <Typography variant="h2">
            {t("PRODUCTS_PAGE.AI_SOFTWARE_PRODUCTS")}
          </Typography>
          <Typography variant="body2">
            {`${counts.approved} ${t("APPROVED")} |
            ${counts.inprogress} ${t("IN_PROGRESS")} |
            ${counts.untrusted} ${t("UNTRUSTED")} |
            ${counts.notSelected} ${t("NOT_SELECTED")}`}
          </Typography>
        </Box>

        <Box className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
          <Typography variant="subtitle2">
            {t("PRODUCTS_PAGE.ADD_NEW_PRODUCT")}
          </Typography>
          <Button
            className="btn-primary-theme"
            variant="contained"
            color="primary"
            onClick={() => setShowAddProductModal(true)}
          >
            <img
              src={icons.addSquare}
              alt={t("PRODUCTS_PAGE.ADD_PRODUCT")}
              className="mr-1"
            />
            {t("CREATE")}
          </Button>
        </Box>
      </Box>
      <DataTableComponent
        tableName="products"
        loading={loading}
        reset={reset}
        columns={columns}
        data={products}
        options={options}
        sort={sortTable}
        pagination={pagination}
        paginate={paginateTable}
        title={
          t("PRODUCTS_PAGE.PRODUCTS_LIST") +
          " (" +
          counts.total +
          t("RESULTS") +
          ")"
        }
        subTitle={""}
        reload={false}
        onReload={refreshData}
        filter={filter}
        onFilterChange={filterChange}
        refresh={refresh}
        clickableRow={["product", "id"]}
      />

      {showAddProductModal && (
        <AddProductModal
          show={showAddProductModal}
          editable={false}
          onClose={(value: any) => handleModalClose(value)}
        />
      )}
    </Box>
  );
};

export default ProductsContent;
